import { gql } from '@/__generated__';

export const STOP_GATE_OPERATION = gql(`#graphql
  mutation StopGateOperation($gateId: ID!) {
    stopGateOperation(input: { gateId: $gateId }) {
      success
    }
  }
`);
